/**
 * Generic "coming soon" portal page.
 *
 * Used until each portal section has its own dedicated page component.
 * Replace per-route in App.js once a section ships real content.
 */
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import PortalEmptyState from "../../components/portal/PortalEmptyState";

export default function PortalPlaceholder({ titleKey, descKey, icon: Icon, testId }) {
  return (
    <div data-testid={testId} className="space-y-10">
      <PortalPageHeader
        kickerKey="portal.placeholder.kicker"
        titleKey={titleKey}
        subtitleKey={descKey}
      />

      <PortalEmptyState
        variant="dashed"
        icon={Icon}
        titleKey="portal.placeholder.soon_title"
        descKey="portal.placeholder.soon_desc"
      />
    </div>
  );
}
